exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".eye {\n    -ms-flex-item-align: right;\n        -ms-grid-row-align: right;\n        align-self: right;\n    margin-left: auto;\n    display: inline-block;\n}\n\n.link-section {\n    display: -ms-flexbox;\n    display: flex;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.scorm-progress-bar{\n  width: 100%;\n  height: 5px;\n  border-radius: 3px;\n  border: 1px solid #a3a3a3;\n  background-color: #EEE;\n  color: #000;\n}\n\n.progress-content{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n\n.bar{\n  background-color: #0084ac;\n  height: 100%;\n  color: #000;\n  border-radius: 3px;\n}\n.progress-text{\n  font-size: 12px;\n  font-weight: bold;\n  padding-top: 3px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/scorm/tile.component.css
// module id = 779
// module chunks = 0